module.exports = __webpack_public_path__ + "img/loginLogo2.a5fd9eee.png";